<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 個人情報保護方針
      span.validation-label 必須
    .register-key
      button.btn.privacy-protection-btn(type="button" @click="openPrivacyProtection()") 個人情報保護方針はこちら

    .register-value
      label
        input(v-model="_value" name="privacy-protection-confirm" type="checkbox" v-validate="{ required: true }" data-vv-as="個人情報保護方針")
        span 同意する

    .error-messages(v-for="error in errors.collect('privacy-protection-confirm')")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import Setting from "../../../../public/setting.json";

/**
 * 入力要素コンポーネント
 *
 * - 個人情報保護方針の入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormPrivacyCheck extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  private value!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * 個人情報保護方針を別タブで開く
   */
  private openPrivacyProtection(): void {
    window.open(Setting.privacyProtectionUrl, "_blank");
  }
}
</script>

<style lang="scss" scoped>
// 画像でセレクトボックスを表現するので、input要素自体は非表示にする
input[type="checkbox"] {
  display: none;

  // input要素の代わりに画像つきのspanにする
  // 選択しているか否かで画像を切り替える
  // for属性でcheckboxと紐づかせたspan要素のclickで、チェックボックスの状態が変更される
  & + span {
    // チェックボックス画像が全て表示されるように高さを指定する
    height: 46px;
    // チェックボックス画像が文字より大きく、文字が縦中央揃えに出来ないので、paddingで上下余白を取って位置調整
    padding: 6px 0 0 40px;
    background: url("../../../assets/login-checkbox-off.png") no-repeat left center;
    // チェックボックス画像のサイズを指定
    // 正方形なので要素の高さと同じになる
    background-size: 32px 32px;
    cursor: pointer;
  }
  &:checked + span {
    background: url("../../../assets/login-checkbox-on.png") no-repeat left center;
    // チェックボックス画像のサイズを指定
    // 正方形なので要素の高さと同じになる
    background-size: 32px 32px;
  }
}
</style>
